import { render, staticRenderFns } from "./lawdetxghd.vue?vue&type=template&id=44bdc0d5&scoped=true&"
import script from "./lawdetxghd.vue?vue&type=script&lang=js&"
export * from "./lawdetxghd.vue?vue&type=script&lang=js&"
import style0 from "./lawdetxghd.vue?vue&type=style&index=0&id=44bdc0d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdc0d5",
  null
  
)

export default component.exports